import { ModelEntityType } from '@upright/common/model/input/types';
import { HeaderSearchSelection } from '@upright/common/model/search/types';
import { useMainContext } from '@upright/ui/views/root/main/context';
import { getSearchSuggestions } from './example-searches';

export function useSuggestions(searchType: HeaderSearchSelection) {
  const mainContext = useMainContext();

  // Here a possibility to query personalized groups for search suggestions instead of static ones
  // in getSearchSuggestions function
  const groups = undefined;

  // TODO ML: Call query hook directly instead of subscribing to main context
  // Outside `MainRoot` there is no `MainContext` (its default is `{}`), and the unified shell's search
  // panel can be mounted there, so the query may be missing: there are then no portfolios to suggest.
  const portfolioQuery = mainContext.getPortfolioSearchSuggestionsQuery as
    | ReturnType<typeof useMainContext>['getPortfolioSearchSuggestionsQuery']
    | undefined;
  const portfolios = portfolioQuery?.data?.map(p => ({
    ...p,
    type: ModelEntityType.PORTFOLIO,
  }));

  const suggestions = getSearchSuggestions(searchType, groups, portfolios);
  return suggestions;
}
